import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[0.6875rem] font-semibold whitespace-nowrap',
  {
    variants: {
      tone: {
        neutral: 'border-rule-strong bg-surface-sunk text-ink-muted',
        brand: 'border-brand-200 bg-brand-50 text-brand-700',
        green: 'border-success-border bg-success-soft text-success-bold',
        yellow: 'border-warn-border bg-warn-soft text-warn-bold',
        red: 'border-danger-border bg-danger-soft text-danger-bold',
        blue: 'border-info-border bg-info-soft text-info-bold',
        violet: 'border-violet-border bg-violet-soft text-violet-bold',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  dot?: boolean;
}

export function Badge({ className, tone, dot, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ tone }), className)} {...props}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />}
      {children}
    </span>
  );
}
